const Audit = () => import("@/components/audit-ppp-front/Audits.vue");
const AuditStepper = () => import("@/components/audit-ppp-front/AuditStepper.vue");
const AuditHistoricalResume = () =>
  import("@/components/audit-ppp-front/audit/AuditHistoricalResume.vue");
const UserProfile = () => import("@/components/audit-ppp-front/UserProfile.vue");

export default [
  {
    path: "",
    name: "Audits",
    component: Audit,
  },
  {
    path: "audit/:uuid?/:step",
    name: "AuditStepper",
    component: AuditStepper,
    props: true,
  },
  {
    path: "audit/:uuid?/resume",
    name: "AuditResume",
    component: AuditHistoricalResume,
    props: true,
  },
  {
    path: "/user-profile",
    component: UserProfile,
    name: "user-profile",
  },
];
